import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { Path } from "react-native-svg";

function MinusIcon({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      <Path fill={finalColor} d="M19,13H5V11H19V13Z" />
    </Svg>
  );
}
export default MinusIcon;
